// src/UI/ActionsMenu/style.ts
import { styled } from "@mui/material/styles";
import { IconButton, Menu, MenuItem } from "@mui/material";

/**
 * Иконка (три точки).
 * Делаем лёгкий hover-эффект в соответствии с вашим UI-китом:
 * например, возьмём цвет hovered из "TextAndIcon.primaryBlackHovered".
 */
export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&:hover": {
    // theme.palette.TextAndIcon.primaryBlackHovered 
    // – это, судя по вашему коду, #0085FF (в lightTheme).
    backgroundColor: theme.palette.TextAndIcon.primaryBlackHovered,
  },
}));

/**
 * Само выпадающее меню (обёртка над MUI Menu).
 * Можно настроить рамку, тень, отступы.
 */
export const StyledMenu = styled(Menu)(({ theme }) => ({
  ".MuiMenu-paper": {
    // Например, тонкая рамка с цветом border.6 
    // (если есть необходимость)
    radius: "16px",
    paddinf: "8px",
    /* border: `1px solid ${theme.palette.border?.[6] || "#ccc"}`, */
    // Небольшая тень:
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    marginTop: 4,
  },
}));

/**
 * Пункты меню.
 * Можно задать цвет текста, фон по ховеру и т.д.
 */
export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  // Предположим, что основной цвет текста берём 
  // из TextAndIcon.primaryBlackEnabled
  color: theme.palette.TextAndIcon.primaryBlackEnabled,

  "&:hover": {
    backgroundColor: theme.palette.background.elements,
  },
}));
